import type { ComponentProps } from 'react';
import { Input as ManagedInput } from '../ui/input';

export function Input(props: ComponentProps<'input'>) {
  // Browser-native non-text inputs retain validation, FileList, date handling,
  // FormData values and the current checkbox/radio selection contracts.
  if (props.type && ['checkbox', 'radio', 'file', 'range', 'color', 'hidden', 'date', 'time', 'datetime-local', 'number'].includes(props.type)) {
    return <input data-slot="input" {...props} />;
  }
  return <ManagedInput {...props} />;
}
